import { FieldType, TYPE_ITEMS_CHOICE_OPTIONS } from "@dto/fields";
import { DecimalValueEditor } from "./DecimalValueEditor";
import { NumberValueEditor } from "./NumberValueEditor";
import { TextValueEditor } from "./TextValueEditor";
import { CurrencyValueEditor } from "./CurrencyValueEditor";
import { ChoiceValueEditor } from "./ChoiceValueEditor";
import { CheckboxValueEditor } from "./CheckboxValueEditor";
import { PercentageValueEditor } from "./PercentageValueEditor";



type ValueEditorProps = {
    format: Map<string, any> | undefined;
    typeItems: Map<string, any> | undefined;
    type: FieldType;
    value: any;
    disabled: boolean;
    onValueChange: (value: any) => void;
    className?: string;
}

export function ValueEditor({ format, typeItems, type, value, disabled, onValueChange, className }: ValueEditorProps) {

    switch (type) {
        case FieldType.Text:
            return <TextValueEditor format={format} value={value} disabled={disabled} onValueChange={onValueChange} className={className} />;
        case FieldType.Number:
            return <NumberValueEditor format={format} value={value} disabled={disabled} onValueChange={onValueChange} />;
        case FieldType.Decimal:
            return <DecimalValueEditor format={format} value={value} disabled={disabled} onValueChange={onValueChange} />;
        case FieldType.Percent:
            return <PercentageValueEditor format={format} value={value} disabled={disabled} onValueChange={onValueChange} />;
        case FieldType.Devise:
            return <CurrencyValueEditor format={format} value={value} disabled={disabled} onValueChange={onValueChange} />;
        case FieldType.Choice:
            return <ChoiceValueEditor options={typeItems?.get(TYPE_ITEMS_CHOICE_OPTIONS) ?? []} isMultiple={false} value={value} disabled={disabled} onValueChange={onValueChange} />;
        case FieldType.MultiChoice:
            return <ChoiceValueEditor options={typeItems?.get(TYPE_ITEMS_CHOICE_OPTIONS) ?? []} isMultiple={true} value={value} disabled={disabled} onValueChange={onValueChange} />;
        case FieldType.Boolean:
            return <CheckboxValueEditor value={value ?? false} disabled={disabled} onValueChange={onValueChange} />;
        default:
            return null;
    }
}